import { render, staticRenderFns } from "./BusinessEngineeringPage.vue?vue&type=template&id=8a96785a&scoped=true&"
import script from "./BusinessEngineeringPage.vue?vue&type=script&lang=js&"
export * from "./BusinessEngineeringPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a96785a",
  null
  
)

export default component.exports